import merge from "lodash/merge";
import api from "./api";
import config from "../config";
import { stringify } from "qs";

export default {
  fetchAllForEvent(apiKey, event) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `events/${event}/tickets`,
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response.tickets);
        }
      );
    });
  },

  fetchAllForPerson(apiKey, person) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `people/${person}/tickets`,
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response.tickets);
        }
      );
    });
  },

  fetchOne(apiKey, ticket) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `tickets/${ticket}`,
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchTicketTransferHistory(apiKey, ticketId, eventBucketId) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `tickets/${ticketId}/history?event_bucket=${eventBucketId}`,
          api_key: apiKey
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  delete(apiKey, accountToken, ticket) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "DELETE",
          endpoint: `tickets/${ticket}`,
          api_key: apiKey,
          qs: {
            token: accountToken
          }
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  deleteBulk(apiKey, data) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "DELETE",
          endpoint: `tickets/delete`,
          json: data,
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  markAsUsed(apiKey, ticket) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `tickets/${ticket}/mark_as_used`,
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  downloadPdf(apiKey, options) {
    options.api_key = apiKey;
    let query = stringify(options);
    window.open(`${config.endpoint}tickets.pdf?${query}`);
  },

  changeTicketsUnlock(apiKey, data) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `tickets/change_unlocks`,
          json: data,
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  transfer(apiKey, tickets, recipient) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: "tickets/transfer",
          json: { recipient, tickets },
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  cancelTransfer(apiKey, transfer) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: "tickets/cancel_transfer",
          json: { transfer },
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  resendTransfer(apiKey, transfer) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: "tickets/resend_transfer",
          json: { transfer },
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  exchangeTickets(apiKey, data) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `tickets/exchange`,
          json: data,
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  changeSeats(apiKey, tickets) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `tickets/change_seats`,
          json: { tickets },
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/utils/TicketUtil.js